import { pipeline } from '@huggingface/transformers';

const [modelDir, model] = process.argv.slice(2);

let text = '';
process.stdin.on('data', chunk => text += chunk);
process.stdin.on('end', async () => {
	const embedder = await pipeline('feature-extraction', 'Xenova/' + model, {cache_dir: modelDir});
	const output = await embedder(text, { pooling: 'mean', normalize: true });
	const embedding = Array.from(output.data);
	process.stdout.write(JSON.stringify({embedding}));
	process.exit();
});
